import { useContext } from "react";

import {
  ClientBudgetContextType,
  ClientBudgetContext,
} from "../contexts/ClientBudget/ClientBudgetContext";

export const useClientBudget = (): ClientBudgetContextType => {
  const context = useContext(ClientBudgetContext);
  if (!context) {
    throw new Error("useClientBudget must be used within a ClientBudgetProvider");
  }
  return context;
};
